import $ from "jquery";
// import { accordion } from "./modules/accordion";
import { anchorScroll } from "./modules/anchorScroll";
import { menu } from "./modules/menu";

$(function () {
  // anchorScroll();
  // accordion();
  menu();
});
